// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f7438b22","803":"036f30fc","929":"16f00c3b","985":"3ca9e8e4"}[chunkId] + ".chunk.js";
};